import { LDFlagSet, useFlags, useLDClient } from 'launchdarkly-react-client-sdk'

import { useAuth } from '@dc-shared-web/providers/AuthProvider'
import { useEffect, useState } from 'react'

export function useLDFlags(additionalContext?: Record<string, unknown>) {
  const client = useLDClient()
  const { isAuthenticating } = useAuth()
  const [forcedFlags, setForcedFlags] = useState<LDFlagSet>()

  // Merge additionalContext with the existing so the existing config isn't overwritten
  // We call this function in lots of places; the provider inits a context, then every call
  // here can potentially add custom context. Beware setting the same additionalContext values
  // in different components creates race conditions for which will be the most recently applied.
  let ldContext = client?.getContext()
  if (ldContext && additionalContext) {
    ldContext = { ...ldContext, ...additionalContext }
    client?.identify(ldContext)
  }

  // check for query params to force flags
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const forceFlags = urlParams.get('forceFlags')
    if (forceFlags) {
      setForcedFlags(
        forceFlags.split('|').reduce((acc, flag) => {
          const [key, value] = flag.split('-')
          acc[key] = value === '1'
          return acc
        }, {} as LDFlagSet)
      )
    }
  }, [])

  const realFlags = useFlags()
  const flags = forcedFlags ? { ...realFlags, ...forcedFlags } : realFlags

  return {
    // "WithLDProvider" is dependent on the user being loaded
    // in order to be at it's final state. To reflect this
    // we check if flags exist and if the user is done loading
    isLoading:
      !Object.keys(client?.allFlags() || {}).length || isAuthenticating,
    isAnonymous: client?.getContext()?.anonymous ?? true,
    flags,
  }
}
